export default {
  date: 'วันที่',
  chooseExpDate: 'เลือกวันที่',
  filterExpDate: 'กรองตามวันที่',
  experienceType: 'ประเภท',
  filterExperienceType: 'กรองตามประเภท',
  experienceVibe: 'บรรยากาศ',
  filterExperienceVibe: 'กรองตามบรรยากาศ',
  search: 'ค้นหา',
  viewCalendar: 'ปฏิทิน',
  back: 'กลับ',
  previous: 'ก่อนหน้า',
  next: 'ถัดไป',
  noExperiences: 'ไม่มีประสบการณ์',
  cancelChanges: 'ยกเลิกการเปลี่ยนแปลง',
  saveChanges: 'บันทึกการเปลี่ยนแปลง',
  removeFromReservation: 'ลบออกจากการจอง',
  addToCart: 'เพิ่มลงตะกร้า',
  proceedToCheckout: 'ดำเนินการชำระเงิน',
  selectDate: 'เลือกวันที่',
  startDate: 'วันที่เริ่มต้น',
  endDate: 'วันที่สิ้นสุด',
  submit: 'ส่ง',
  filterExperienceTypeScreenReader:
    'ใช้ตัวกรองเหล่านี้เพื่อจำกัดผลลัพธ์ เนื้อหาจะอัปเดตโดยอัตโนมัติเมื่อเลือกตัวกรอง',
};
